module.exports = __webpack_public_path__ + "img/btn-bg.58c8e8eb.png";